webpackJsonp([89127590239909],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TilesModule = __webpack_require__(159);
	
	var _TilesModule2 = _interopRequireDefault(_TilesModule);
	
	var _Link = __webpack_require__(55);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tiles = function Tiles(_ref) {
	  var entries = _ref.entries;
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _TilesModule2.default.flex },
	      _react2.default.createElement(_Link2.default, { className: _TilesModule2.default.header, name: 'referenzen', tag: 'h2' }),
	      _react2.default.createElement(
	        'div',
	        { className: _TilesModule2.default.grid },
	        entries.map(function (_ref2, i) {
	          var image = _ref2.image,
	              title = _ref2.title,
	              text = _ref2.text;
	
	          return _react2.default.createElement(
	            'div',
	            { key: title + '_' + i, className: _TilesModule2.default.tile },
	            _react2.default.createElement('div', { className: _TilesModule2.default.image, style: { backgroundImage: image ? 'url(' + image.file.url + ')' : undefined } }),
	            _react2.default.createElement(
	              'span',
	              { className: _TilesModule2.default.animateText },
	              _react2.default.createElement(
	                'h4',
	                null,
	                title
	              ),
	              text ? _react2.default.createElement(
	                'h4',
	                null,
	                text.text
	              ) : null
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	Tiles.propTypes = {
	  entries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image: _propTypes2.default.shape({
	      file: _propTypes2.default.shape({
	        url: _propTypes2.default.string
	      })
	    }),
	    title: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.shape({
	      text: _propTypes2.default.string
	    })
	  })).isRequired
	};
	
	exports.default = Tiles;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components----Tiles-module---flex---3ceW7","header":"src-components----Tiles-module---header---3FZRS","animateText":"src-components----Tiles-module---animateText---338jR","grid":"src-components----Tiles-module---grid---kli2J","image":"src-components----Tiles-module---image---4JevU","tile":"src-components----Tiles-module---tile---1T6hM"};

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(56);
	
	var _subpage = __webpack_require__(138);
	
	var _subpage2 = _interopRequireDefault(_subpage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Verkauf = function Verkauf(_ref) {
	  var _ref$pathContext = _ref.pathContext,
	      subparts = _ref$pathContext.subparts,
	      references = _ref$pathContext.references;
	
	  var _sanitizeContent = (0, _utils.sanitizeContent)(subparts, 'verkauf'),
	      verkauf = _sanitizeContent.verkauf;
	
	  return _react2.default.createElement(_subpage2.default, { blocks: [{ content: [_extends({}, verkauf[0], { onContact: function onContact() {
	          return (0, _utils.scrollToElement)('#kontakt');
	        } })] }], references: references });
	};
	
	Verkauf.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    subparts: _propTypes2.default.array.isRequired,
	    references: _propTypes2.default.array.isRequired
	  })
	};
	
	exports.default = Verkauf;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Blocks = __webpack_require__(93);
	
	var _Blocks2 = _interopRequireDefault(_Blocks);
	
	var _Tiles = __webpack_require__(137);
	
	var _Tiles2 = _interopRequireDefault(_Tiles);
	
	var _subpageModule = __webpack_require__(160);
	
	var _subpageModule2 = _interopRequireDefault(_subpageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubPage = function SubPage(_ref) {
	  var blocks = _ref.blocks,
	      references = _ref.references;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _subpageModule2.default.wrapper },
	    blocks.map(function (block, i) {
	      return _react2.default.createElement(_Blocks2.default, _extends({ key: i, headerTag: 'h2' }, block, { classNames: _extends({ cards: _subpageModule2.default.mdList }, block.classNames || {}) }));
	    }),
	    references && !!references.length && _react2.default.createElement(_Tiles2.default, { entries: references })
	  );
	};
	
	SubPage.propTypes = {
	  blocks: _propTypes2.default.array.isRequired,
	  references: _propTypes2.default.array.isRequired
	};
	
	exports.default = SubPage;
	module.exports = exports['default'];

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-templates----subpage-module---wrapper---3jtzs","mdList":"src-templates----subpage-module---mdList---2-k5B"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-verkauf-js-2ae0118cb54ca504176a.js